import { render } from "./NumberInput.vue?vue&type=template&id=a33998ee&scoped=true&ts=true"
import script from "./NumberInput.vue?vue&type=script&lang=ts"
export * from "./NumberInput.vue?vue&type=script&lang=ts"

import "./NumberInput.vue?vue&type=style&index=0&id=a33998ee&scoped=true&lang=css"

import exportComponent from "/builds/entersekt/repos/sdk-browser/saas-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a33998ee"]])

export default __exports__